import Vue from 'vue/dist/vue.esm';
import TurbolinksAdapter from 'vue-turbolinks';

// Import Plugins
import MainPlugin from '../../javascripts/plugins/main';

// Import Third Partie Libs
import VueTheMask from 'vue-the-mask';
import money from 'v-money';

// Import Indexes
import '../../images/index.js.erb';
import '../../javascripts/components/index.js.erb';
import '../../javascripts/components/search/datePicker';
import '../../javascripts/components/search/authenticationCodeInputs';
import '../../javascripts/components/shared/cnpjInput';
import '../../javascripts/components/search/otherJobTitleFields';

Vue.use(TurbolinksAdapter);
Vue.use(MainPlugin);

// Register Third Parties Libs
Vue.use(VueTheMask);
Vue.use(money, {precision:2});

window.updateFileName = function(input) {
    const fileBox = input.closest('.file-box');
    const fileName = fileBox && fileBox.querySelector('.file-name');

    if (!fileName) return;

    fileName.textContent = input.files.length > 0
        ? Array.from(input.files).map(file => file.name).join(', ')
        : 'Nenhum arquivo adicionado';
}

function updateSearchProfileUploadCard(input) {
    const card = input.closest('[data-upload-card]');
    if (!card) return;

    const fileName = card.querySelector('[data-upload-file-name]');
    const placeholder = card.querySelector('[data-upload-placeholder]');
    const help = card.querySelector('[data-upload-help]');
    const icon = card.querySelector('[data-upload-icon]');
    const selectedFile = input.files && input.files[0];
    const hasExistingFile = input.dataset.uploadExistingFile === 'true';
    const maxPdfSize = 5 * 1024 * 1024;
    const isOversizedPdf = selectedFile &&
        selectedFile.type === 'application/pdf' &&
        selectedFile.size > maxPdfSize;

    if (isOversizedPdf) {
        input.value = '';
    }

    card.classList.toggle('is-selected', (Boolean(selectedFile) || hasExistingFile) && !isOversizedPdf);
    card.classList.toggle('is-invalid', Boolean(isOversizedPdf));

    if (fileName) {
        if (isOversizedPdf) {
            fileName.textContent = 'Não é possível adicionar PDF com mais de 5MB.';
        } else if (selectedFile) {
            fileName.textContent = selectedFile.name;
        } else if (!hasExistingFile) {
            fileName.textContent = '';
        }
    }
    if (placeholder) placeholder.classList.toggle('d-none', (Boolean(selectedFile) || hasExistingFile) && !isOversizedPdf);
    if (help) help.classList.toggle('d-none', Boolean(selectedFile) || hasExistingFile || Boolean(isOversizedPdf));
    if (icon) icon.classList.toggle('d-none', (Boolean(selectedFile) || hasExistingFile) && !isOversizedPdf);
}

function initSearchProfileUploads() {
    document.querySelectorAll('[data-upload-input]').forEach(updateSearchProfileUploadCard);
}

document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-upload-input]')) return;

    updateSearchProfileUploadCard(event.target);
});

document.addEventListener('click', (event) => {
    const clearButton = event.target.closest('[data-upload-clear]');
    if (!clearButton) return;

    const card = clearButton.closest('[data-upload-card]');
    const input = card && card.querySelector('[data-upload-input]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    input.value = '';
    input.dataset.uploadExistingFile = 'false';
    updateSearchProfileUploadCard(input);
});

document.addEventListener('DOMContentLoaded', initSearchProfileUploads);
document.addEventListener('turbolinks:load', initSearchProfileUploads);

document.addEventListener('turbolinks:load', () => {
    const element = document.getElementById('appAdmin');
    if (element != null) {
        const app = new Vue({
            el: '#appAdmin',
            data() {
                return {
                    menuCheckbox: false,
                }
            },
            mounted() {
                window.addEventListener('resize', this.handleMenuResize);
            },
            beforeDestroy() {
                window.removeEventListener('resize', this.handleMenuResize);
            },
            watch: {
                menuCheckbox(isOpen) {
                    this.$el.classList.toggle('no-scroll', isOpen);
                },
            },
            methods: {
                handleMenuResize() {
                    if (window.innerWidth >= 1200) {
                        this.menuCheckbox = false;
                    }
                },
            },
        });
        console.log('Loaded Vue');
    }
})
